import { createDefault } from "../utils/ConstUtils";

export default createDefault([
  { value: 1, text: "新規登録" },
  { value: 2, text: "入荷待ち" },
  { value: 3, text: "入荷済み" },
  { value: 4, text: "キャンセル" },
]);
